import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import {
  ApexChart,
  ApexDataLabels,
  ApexLegend,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexTitleSubtitle,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { getComcastChartPalette } from 'src/app/shared/constants/chart-colors';

import { IqUseCaseSummary } from '../../domain/iq-aggregated-dashboard.model';

type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  title: ApexTitleSubtitle;
  legend: ApexLegend;
  colors: string[];
  plotOptions: ApexPlotOptions;
  dataLabels: ApexDataLabels;
};

@Component({
  selector: 'app-iq-aggregated-use-case-pie-chart',
  templateUrl: './iq-aggregated-use-case-pie-chart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgApexchartsModule],
})
export class IqAggregatedUseCasePieChartComponent {
  readonly data = input<IqUseCaseSummary[]>([]);

  /** Deferred update() after mount so % height sees the final flex layout. */
  onChartReady(payload: unknown): void {
    const chartObj = (payload as { chartObj?: { update: () => Promise<unknown> } })
      .chartObj;
    if (!chartObj?.update) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        void chartObj.update();
      });
    });
  }

  readonly chartOptions = computed<Partial<ChartOptions>>(() => {
    const rows = this.data() ?? [];
    const series = rows.map((item) => item.count);
    const labels = rows.map((item) => item.useCase);

    return {
      series,
      labels,
      chart: {
        height: '100%',
        type: 'donut',
        parentHeightOffset: 0,
      },
      plotOptions: {
        pie: {
          donut: {
            size: '62%',
          },
          customScale: 1.0,
          expandOnClick: false,
        },
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        floating: false,
      },
      dataLabels: {
        enabled: true,
        formatter: (val: number, opts: any): string => {
          const count = opts.w.config.series[opts.seriesIndex] as number;
          return `${Math.round(val)}%(${count})`;
        },
      },
      colors: getComcastChartPalette(),
    };
  });
}
